
import React, { useState } from "react";
import api from "./api";
import "./Login.css";
import ForgotPassword from "./ForgotPassword";

const Login = ({ onLoginSuccess }) => {
    const [clientNumber, setClientNumber] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [showForgotPassword, setShowForgotPassword] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setMessage("");
        setLoading(true);

        try {
            const res = await api.post("/login.php", {
                nr_user: clientNumber,
                password
            });

            if (res.data.error) {
                setMessage(res.data.error);
            } else if (res.data.message === "Zalogowano") {
                await onLoginSuccess();
            } else {
                setMessage("Nie udało się zalogować.");
            }
        } catch (err) {
            console.error("Błąd logowania:", err);
            console.error("Status HTTP:", err.response?.status);
            console.error("Odpowiedź serwera:", err.response?.data);

            setMessage(
                err.response?.data?.error ||
                err.message ||
                "Błąd logowania Js."
            );
        } finally {
            setLoading(false);
        }
    };


    if (showForgotPassword) {
        return (
            <ForgotPassword
                onBack={() => setShowForgotPassword(false)}
            />
        );
    }

    return (
        <div className="login-page">
            <div className="login-box">
                <h2>ROD ZGODA Bytom</h2>
                <h2>Panel Działkowca</h2>
                <p className="subtitle">
                    Zaloguj się do swojego konta
                </p>

                <form onSubmit={handleLogin}>
                    <input
                        type="text"
                        placeholder="Identyfikator"
                        value={clientNumber}
                        onChange={(e) => setClientNumber(e.target.value)}
                        required
                    />

                    <input
                        type="password"
                        placeholder="Hasło"
                        value={password}
                        onChange={(e) =>
                            setPassword(e.target.value)
                        }
                        autoComplete="current-password"
                        required
                    />

                    <button type="submit" disabled={loading}>
                        {loading ? "Logowanie..." : "Zaloguj się"}
                    </button>
                    <button
                        type="button"
                        onClick={() => setShowForgotPassword(true)}
                    >
                        Nie pamiętam hasła
                    </button>
                </form>

                {message && (
                    <p className="message" role="alert">
                        {message}
                    </p>
                )}
            </div>
        </div>
    );
};

export default Login;